


export type FormDefinitionAccess = 'Extern' | 'Intern';

export const FormDefinitionAccess = {
    Extern: 'Extern' as FormDefinitionAccess,
    Intern: 'Intern' as FormDefinitionAccess
};

